import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const ExerciseVideos = ({ exerciseVideos, name, isLoading }) => {
  return (
    <Box sx={{ marginTop: { lg: "40px", xs: "20px" }, p: "20px" }}>
      <Typography variant="h4" mb="50px">
        Watch {name} exercise videos
      </Typography>
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          flexDirection: { lg: "row" },
          columnGap: { lg: "100px", xs: "0" },
          rowGap: { lg: "60px", xs: "40px" },
          flexWrap: "wrap",
        }}
      >
        {isLoading ? (
          <div
            style={{
              margin: "auto",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              border: "6px solid #f3f3f3",
              borderTop: "6px solid #ee2625",
              animation: "spin 1s linear infinite",
            }}
          ></div>
        ) : (
          exerciseVideos?.slice(0, 6).map((item, index) => (
            <iframe
              // loading="lazy"
              key={index}
              className="exercise-video"
              style={{ border: "none" }}
              src={`https://youtube.com/embed/${item.video.videoId}`}
              title={item.video.title}
            ></iframe>
          ))
        )}
      </Stack>
    </Box>
  );
};

export default ExerciseVideos;
